module.exports = __webpack_public_path__ + "static/media/chevron-down-light.941efb7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-down-light.svg
// module id = 726
// module chunks = 0